import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    balanceListing: null,
    metaData: null,
    currentPage: 1,
    mounted: false,
    classId: '0',
    residenceId: '0',
    searchText: '',
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const SchWalletBalanceContext = createContext();

export const SchWalletBalanceProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

   useEffect(()=>{
      if(state.mounted){
        getbalanceListing();
      }
    }, [state.currentPage])

  const getbalanceListing = async (refresh = false) => {

    dispatch({ type: "mounted", payload: true });

    if (refresh) {
        dispatch({ type: "balanceListing", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
      }

    const payloadData = {
        'page':refresh ? 1: state.currentPage,
        'student_class': state.classId,
        'student_residence': state.residenceId,
        
      };


    const server_response  = await ajaxSchool.fetchWalletBalances(payloadData);
      if(server_response.status === "OK"){
        
            const newTransactions = server_response.details.data;
            dispatch({
            type: "balanceListing",
            payload: refresh
                ? newTransactions
                : state.balanceListing
                ? [...state.balanceListing, ...newTransactions]
                : newTransactions
            });

          dispatch({ type: "metaData", payload: server_response.details.meta });

      }else{
        dispatch({ type: 'balanceListing', payload: '404' });
        dispatch({ type: "meta", payload: "404" });

      }
  };



  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }

  const filter = async()=>{
    await getbalanceListing(true);
  }


  return(
    <SchWalletBalanceContext.Provider value={{
      ...state, 
      dispatch, 
      getbalanceListing,
      setCurrentPage,
      filter
      }}>
      {children}
    </SchWalletBalanceContext.Provider>
  )

}

export const useSchWalletBalance = ()=>useContext(SchWalletBalanceContext);

